// extracted by mini-css-extract-plugin
module.exports = {"component":"index_component__3Wz81","item":"index_item__2jcUQ"};